import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimulacionComponent } from './components/simulacion/simulacion.component';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { DetalleArmoticacionModalComponent } from './components/modals/detalle-armoticacion-modal/detalle-armoticacion-modal.component';
import { RediferidosRoutingModule } from './rediferidos.routing.module';



@NgModule({
  declarations: [
    SimulacionComponent,
    OnlyNumbersDirective,
    DetalleArmoticacionModalComponent,
  ],
  imports: [
    CommonModule,
    RediferidosRoutingModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    ImportsModule,
    SharedModule,
  ]
})
export class RediferidosModule { }
